import { HeadCell } from 'models';
import { ACTIVITY_LOG_ITEM_TYPE } from 'models/activity-logs';

export const headCells: readonly HeadCell<ACTIVITY_LOG_ITEM_TYPE>[] = [
  {
    id: 'number',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Activity ID',
  },
  {
    id: 'action',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Action',
  },
  {
    id: 'created_by',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Actor Name',
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Description',
  },
  {
    id: 'created_by_role',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created By',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Created At',
  },
];
